export const galleryOptions = {
    'alt': ['alt-photo', 'center-photo'],
    'big-centered-stream': ['big-center-photo'],
}

export const readableNames = {
    'alt': 'Alternating',
    'alt-photo': 'Alternating photo',
    'center-photo': 'Center photo',
    'big-centered-stream': 'Big centered stream',
    'big-center-photo': 'Big center photo',
} as const